/* eslint-disable */
export const summary2026 = {
  totalDays: 365,
  workDays: 241,
  nonWorkDays: 124,
  workHours40: 1922,
  workHours36: 1730,
  workHours24: 1154,
}

export const quarters = [
  {
    id: 1,
    name: { AZ: 'I Rüb', ENG: '1st Quarter', RU: 'I Квартал', TR: '1. Çeyrek' },
    period: { AZ: 'Yanvar — Mart', ENG: 'January — March', RU: 'Январь — Март', TR: 'Ocak — Mart' },
    workDays: 54,
    nonWorkDays: 36,
    workHours: 430,
    monthIndices: [0, 1, 2],
  },
  {
    id: 2,
    name: { AZ: 'II Rüb', ENG: '2nd Quarter', RU: 'II Квартал', TR: '2. Çeyrek' },
    period: { AZ: 'Aprel — İyun', ENG: 'April — June', RU: 'Апрель — Июнь', TR: 'Nisan — Haziran' },
    workDays: 60,
    nonWorkDays: 31,
    workHours: 478,
    monthIndices: [3, 4, 5],
  },
  {
    id: 3,
    name: { AZ: 'III Rüb', ENG: '3rd Quarter', RU: 'III Квартал', TR: '3. Çeyrek' },
    period: { AZ: 'İyul — Sentyabr', ENG: 'July — September', RU: 'Июль — Сентябрь', TR: 'Temmuz — Eylül' },
    workDays: 66,
    nonWorkDays: 26,
    workHours: 528,
    monthIndices: [6, 7, 8],
  },
  {
    id: 4,
    name: { AZ: 'IV Rüb', ENG: '4th Quarter', RU: 'IV Квартал', TR: '4. Çeyrek' },
    period: { AZ: 'Oktyabr — Dekabr', ENG: 'October — December', RU: 'Октябрь — Декабрь', TR: 'Ekim — Aralık' },
    workDays: 63,
    nonWorkDays: 29,
    workHours: 503,
    monthIndices: [9, 10, 11],
  },
]

export const weekdayHeaders = {
  AZ: ['B.e', 'Ç.a', 'Ç', 'C.a', 'C', 'Ş', 'B'],
  ENG: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
  RU: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
  TR: ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'],
}

export const months2026 = [
  {
    index: 0,
    quarter: 1,
    name: { AZ: 'Yanvar', ENG: 'January', RU: 'Январь', TR: 'Ocak' },
    days: 31,
    startOffset: 3,
    workDays: 20,
    nonWorkDays: 11,
    workHours: 159,
    specialDays: {
      1: { type: 'holiday', title: { AZ: 'Yeni il bayramı', ENG: "New Year's Day", RU: 'Новый год' } },
      2: { type: 'holiday', title: { AZ: 'Yeni il bayramı', ENG: "New Year's Day", RU: 'Новый год' } },
      19: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Сокращенный рабочий день на 1 час (7ч)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      20: { type: 'mourning', title: { AZ: 'Ümumxalq hüzn günü (20 Yanvar)', ENG: 'National Mourning Day', RU: 'День всенародной скорби', TR: '20 Ocak Ulusal Yas Günü' } },
    },
  },
  {
    index: 1,
    quarter: 1,
    name: { AZ: 'Fevral', ENG: 'February', RU: 'Февраль', TR: 'Şubat' },
    days: 28,
    startOffset: 6,
    workDays: 20,
    nonWorkDays: 8,
    workHours: 160,
    specialDays: {},
  },
  {
    index: 2,
    quarter: 1,
    name: { AZ: 'Mart', ENG: 'March', RU: 'Март', TR: 'Mart' },
    days: 31,
    startOffset: 6,
    workDays: 14,
    nonWorkDays: 17,
    workHours: 111,
    specialDays: {
      8: { type: 'holiday', title: { AZ: 'Qadınlar günü', ENG: "Women's Day", RU: 'Женский день' } },
      9: { type: 'holiday', title: { AZ: 'Qadınlar gününün köçürülmüş istirahət günü', ENG: "Transferred Women's Day", RU: 'Перенесенный выходной день (Женский день)' } },
      19: { type: 'shortened', title: { AZ: 'Novruzqabağı 1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: 'Nevruz öncesi 1 saat kısaltılmış iş günü (7 saat)' } },
      20: { type: 'holiday', title: { AZ: 'Novruz və Ramazan bayramı', ENG: 'Novruz & Ramadan Holiday', RU: 'Праздник Новруз и Рамазан', TR: 'Nevruz ve Ramazan Bayramı' } },
      21: { type: 'holiday', title: { AZ: 'Novruz və Ramazan bayramı', ENG: 'Novruz & Ramadan Holiday', RU: 'Праздник Новруз и Рамазан', TR: 'Nevruz ve Ramazan Bayramı' } },
      22: { type: 'holiday', title: { AZ: 'Novruz bayramı', ENG: 'Novruz Holiday', RU: 'Праздник Новруз', TR: 'Nevruz Bayramı' } },
      23: { type: 'holiday', title: { AZ: 'Novruz bayramı', ENG: 'Novruz Holiday', RU: 'Праздник Новруз', TR: 'Nevruz Bayramı' } },
      24: { type: 'holiday', title: { AZ: 'Novruz bayramı', ENG: 'Novruz Holiday', RU: 'Праздник Новруз', TR: 'Nevruz Bayramı' } },
      25: { type: 'holiday', title: { AZ: 'Ramazan bayramı ilə əlaqədar istirahət günü', ENG: 'Ramadan Holiday non-working day', RU: 'Перенесенный выходной день (Рамазан)', TR: 'Ramazan Bayramı tatili' } },
      26: { type: 'holiday', title: { AZ: 'Ramazan bayramı ilə əlaqədar istirahət günü', ENG: 'Ramadan Holiday non-working day', RU: 'Перенесенный выходной день (Рамазан)', TR: 'Ramazan Bayramı tatili' } },
      27: { type: 'holiday', title: { AZ: 'Ramazan bayramı ilə əlaqədar istirahət günü', ENG: 'Ramadan Holiday non-working day', RU: 'Перенесенный выходной день (Рамазан)', TR: 'Ramazan Bayramı tatili' } },
      30: { type: 'holiday', title: { AZ: 'Ramazan bayramı ilə əlaqədar istirahət günü', ENG: 'Ramadan Holiday non-working day', RU: 'Перенесенный выходной день (Рамазан)', TR: 'Ramazan Bayramı tatili' } },
    },
  },
  {
    index: 3,
    quarter: 2,
    name: { AZ: 'Aprel', ENG: 'April', RU: 'Апрель', TR: 'Nisan' },
    days: 30,
    startOffset: 2,
    workDays: 22,
    nonWorkDays: 8,
    workHours: 176,
    specialDays: {},
  },
  {
    index: 4,
    quarter: 2,
    name: { AZ: 'May', ENG: 'May', RU: 'Май', TR: 'Mayıs' },
    days: 31,
    startOffset: 4,
    workDays: 18,
    nonWorkDays: 13,
    workHours: 142,
    specialDays: {
      8: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      9: { type: 'holiday', title: { AZ: 'Faşizm üzərində qələbə günü', ENG: 'Victory Day', RU: 'День Победы', TR: '9 Mayıs Zafer Günü' } },
      11: { type: 'holiday', title: { AZ: 'Qələbə gününün köçürülmüş istirahət günü', ENG: 'Transferred Victory Day', RU: 'Перенесенный выходной день (День Победы)', TR: 'Zafer Günü telafi tatili' } },
      26: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      27: { type: 'holiday', title: { AZ: 'Qurban bayramı', ENG: 'Eid al-Adha', RU: 'Праздник Гурбан', TR: 'Kurban Bayramı' } },
      28: { type: 'holiday', title: { AZ: 'Qurban bayramı və Müstəqillik günü', ENG: 'Eid al-Adha & Independence Day', RU: 'Праздник Гурбан и День независимости', TR: 'Kurban Bayramı ve Bağımsızlık Günü' } },
      29: { type: 'holiday', title: { AZ: 'Müstəqillik gününün köçürülmüş istirahət günü', ENG: 'Transferred Independence Day', RU: 'Перенесенный выходной день (День независимости)', TR: 'Bağımsızlık Günü telafi tatili' } },
    },
  },
  {
    index: 5,
    quarter: 2,
    name: { AZ: 'İyun', ENG: 'June', RU: 'Июнь', TR: 'Haziran' },
    days: 30,
    startOffset: 0,
    workDays: 20,
    nonWorkDays: 10,
    workHours: 160,
    specialDays: {
      15: { type: 'holiday', title: { AZ: 'Milli Qurtuluş günü', ENG: 'National Salvation Day', RU: 'День национального спасения', TR: '15 Haziran Milli Kurtuluş Günü' } },
      26: { type: 'holiday', title: { AZ: 'Silahlı Qüvvələr günü', ENG: 'Armed Forces Day', RU: 'День Вооруженных сил', TR: '26 Haziran Silahlı Kuvvetler Günü' } },
    },
  },
  {
    index: 6,
    quarter: 3,
    name: { AZ: 'İyul', ENG: 'July', RU: 'Июль', TR: 'Temmuz' },
    days: 31,
    startOffset: 2,
    workDays: 23,
    nonWorkDays: 8,
    workHours: 184,
    specialDays: {},
  },
  {
    index: 7,
    quarter: 3,
    name: { AZ: 'Avqust', ENG: 'August', RU: 'Август', TR: 'Ağustos' },
    days: 31,
    startOffset: 5,
    workDays: 21,
    nonWorkDays: 10,
    workHours: 168,
    specialDays: {},
  },
  {
    index: 8,
    quarter: 3,
    name: { AZ: 'Sentyabr', ENG: 'September', RU: 'Сентябрь', TR: 'Eylül' },
    days: 30,
    startOffset: 1,
    workDays: 22,
    nonWorkDays: 8,
    workHours: 176,
    specialDays: {
      27: { type: 'commemoration', title: { AZ: 'Anım günü', ENG: 'Memorial Day', RU: 'День памяти', TR: '27 Eylül Anma Günü' } },
    },
  },
  {
    index: 9,
    quarter: 4,
    name: { AZ: 'Oktyabr', ENG: 'October', RU: 'Октябрь', TR: 'Ekim' },
    days: 31,
    startOffset: 3,
    workDays: 22,
    nonWorkDays: 9,
    workHours: 176,
    specialDays: {
      18: { type: 'commemoration', title: { AZ: 'Müstəqilliyin Bərpası Günü (İş günüdür)', ENG: 'Restoration of Independence Day (working day)', RU: 'День восстановления независимости (рабочий день)', TR: 'Bağımsızlığın Yeniden Sağlanması Günü (İş günü)' } },
    },
  },
  {
    index: 10,
    quarter: 4,
    name: { AZ: 'Noyabr', ENG: 'November', RU: 'Ноябрь', TR: 'Kasım' },
    days: 30,
    startOffset: 6,
    workDays: 19,
    nonWorkDays: 11,
    workHours: 152,
    specialDays: {
      8: { type: 'holiday', title: { AZ: 'Zəfər günü', ENG: 'Victory Day', RU: 'День Победы', TR: '8 Kasım Zafer Günü' } },
      9: { type: 'holiday', title: { AZ: 'Dövlət Bayrağı günü', ENG: 'State Flag Day', RU: 'День Государственного флага', TR: '9 Kasım Devlet Bayrağı Günü' } },
      10: { type: 'holiday', title: { AZ: 'Zəfər gününün köçürülmüş istirahət günü', ENG: 'Transferred Victory Day', RU: 'Перенесенный выходной день (День Победы)', TR: 'Zafer Günü telafi tatili' } },
      12: { type: 'commemoration', title: { AZ: 'Konstitusiya günü (İş günüdür)', ENG: 'Constitution Day (working day)', RU: 'День Конституции (рабочий день)', TR: '12 Kasım Anayasa Günü (İş günü)' } },
      17: { type: 'commemoration', title: { AZ: 'Milli Dirçəliş günü (İş günüdür)', ENG: 'National Revival Day (working day)', RU: 'День национального возрождения (рабочий день)', TR: '17 Kasım Milli Diriliş Günü (İş günü)' } },
    },
  },
  {
    index: 11,
    quarter: 4,
    name: { AZ: 'Dekabr', ENG: 'December', RU: 'Декабрь', TR: 'Aralık' },
    days: 31,
    startOffset: 1,
    workDays: 22,
    nonWorkDays: 9,
    workHours: 175,
    specialDays: {
      30: { type: 'shortened', title: { AZ: '1 saat qısaldılmış iş günü (7 saat)', ENG: '1 hour shortened work day (7h)', RU: 'Предпраздничный день (сокращен на 1 час)', TR: '1 saat kısaltılmış iş günü (7 saat)' } },
      31: { type: 'holiday', title: { AZ: 'Dünya Azərbaycanlılarının Həmrəyliyi günü', ENG: 'International Solidarity Day of Azerbaijanis', RU: 'День солидарности азербайджанцев мира', TR: '31 Aralık Dünya Azerbaycanlılarının Dayanışma Günü' } },
    },
  },
];
